<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 ml-0 md:ml-4 aarni-font">Refund Policy</h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>

        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200 h-fit bg-white aarni-font text-justify">
            <h2 class="text-2xl font-bold mt-4">Refund Policy</h2>
            <h5 class="text-xl font-bold mt-4 text-gray-800">Welcome to ARNI University, Bringing Ambitions to
                Life.</h5>
            <h6>ARNI University is committed to transparency and fairness in its admissions process. In alignment with
                the University Grants Commission (UGC) guidelines, the university has established a structured refund
                policy for students who choose to withdraw their admission after making full or partial fee
                payments.</h6>
            <h5 class="text-xl font-bold mt-4">Fee Refund Structure</h5>
            <h6>The refund amount is determined by the timing of the withdrawal request relative to the formally
                notified last date of admission:
            </h6>
            <div class="overflow-x-auto my-4 text-gray-800">
                <table class="min-w-full table-auto border border-gray-300 text-sm text-left">
                    <thead class="bg-gray-100 text-gray-700">
                    <tr>
                        <th class="border px-4 py-2">Category</th>
                        <th class="border px-4 py-2">Percentage of Refund</th>
                        <th class="border px-4 py-2">Timeframe for Withdrawal</th>
                    </tr>
                    </thead>
                    <tbody class="text-gray-800">
                    <tr>
                        <td class="border px-4 py-2">1</td>
                        <td class="border px-4 py-2">100%</td>
                        <td class="border px-4 py-2">15 days or more before the last date of admission</td>
                    </tr>
                    <tr>
                        <td class="border px-4 py-2">2</td>
                        <td class="border px-4 py-2">90%</td>
                        <td class="border px-4 py-2">Less than 15 days before the last date of admission</td>
                    </tr>
                    <tr>
                        <td class="border px-4 py-2">3</td>
                        <td class="border px-4 py-2">80%</td>
                        <td class="border px-4 py-2">15 days or less after the last date of admission</td>
                    </tr>
                    <tr>
                        <td class="border px-4 py-2">4</td>
                        <td class="border px-4 py-2">50%</td>
                        <td class="border px-4 py-2">30 days or less, but more than 15 days after the last date of
                            admission
                        </td>
                    </tr>
                    <tr>
                        <td class="border px-4 py-2">5</td>
                        <td class="border px-4 py-2">0%</td>
                        <td class="border px-4 py-2">More than 30 days after the last date of admission</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <p><span class="font-semibold">*Note:</span> The refund percentages apply to the course fee and non-tuition
                fees, excluding caution money and
                security deposits.
            </p>
            <h5 class="text-xl font-bold mt-4">Additional Guidelines</h5>
            <ul class="list-disc pl-5 text-gray-800">
                <li>One-Time Admission Charges: In cases of withdrawal, the one-time admission charges, including the
                    security amount specified in the fee structure, will be deducted by the university.
                </li>
                <li>Hostel and Mess Fees: Hostel semester fees are non-refundable if the student cancels during the
                    semester. However, hostel security charges are refundable upon exit, provided there are no
                    outstanding dues.
                </li>
                <li>Transport Fees: Transport charges are payable in advance and are non-refundable once paid.
                </li>
                <li>Application Procedure: To initiate a refund, students must submit a formal withdrawal application
                    to the Registrar's Office, accompanied by the original fee receipt and other relevant documents.
                </li>
            </ul>

            <h6 class="my-2 text-gray-800">For detailed information or assistance regarding the refund process, please
                visit the official refund
                policy page or contact our Admission Helpline at 1800-891-8962.
            </h6>
            <h6 class="text-gray-800">ARNI University ensures that its refund policies are student-centric, aiming to
                provide clarity and
                fairness to all applicants.
            </h6>
        </section>
    </div>

</div>
